import { DCarouselRef } from "@dfa/ui-platform";
import ImageArrowInCircle from "components/utility/images/ImageArrowInCircle";

type CarouselActionsProps = {
	carouselRef: React.RefObject<DCarouselRef>;
	clickNumber: number;
	clicksToEnd: number;
	currentSection: number;
	prevBtnClass?: string;
	nextBtnClass?: string;
	totalSections: number;
};
const CarouselNavigation = ({
	carouselRef,
	clickNumber,
	clicksToEnd,
	currentSection,
	prevBtnClass,
	nextBtnClass,
	totalSections
}: CarouselActionsProps) => {
	return (
		<div className="carousel-card-dots-container">
			<button
				className={`carousel-card-arrow-btn-prev ${prevBtnClass ? prevBtnClass : ""}`}
				disabled={currentSection === 0}
				onClick={() => carouselRef.current?.previous()}
				aria-label="Previous Card"
				data-a-evt="Link Click"
				data-a-name="Left Indicator"
				data-a-comp="Card Carousel"
			>
				<ImageArrowInCircle />
			</button>
			<ul className="carousel-card-dots-container-dots">
				{Array(clicksToEnd + 1)
					.fill(undefined)
					.map((_, index) => {
						return (
							<li
								key={index}
								className={`carousel-dot ${clickNumber === index ? "active-dot" : ""}`}
							/>
						);
					})}
			</ul>
			<button
				className={`carousel-card-arrow-btn-next ${nextBtnClass ? nextBtnClass : ""}`}
				disabled={currentSection === totalSections}
				onClick={() => carouselRef.current?.next()}
				aria-label="Next Card"
				data-a-evt="Link Click"
				data-a-name="Right Indicator"
				data-a-comp="Card Carousel"
			>
				<ImageArrowInCircle />
			</button>
		</div>
	);
};

export default CarouselNavigation;
